import { Link } from "@mui/material";
import { Link as RouteLink } from "react-router-dom";
import { useIsLinkActive } from "../../hooks";

export type NavLinkProps = {
  title?: string;
  icon: React.ComponentType;
  to: string;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  className?: string;
};

export const NavLink = ({ icon: Icon, title, to, onClick = () => {}, className }: NavLinkProps) => {
  const isActive = useIsLinkActive(to);
  return (
    <Link
      className={className}
      onClick={onClick}
      sx={{
        color: "text.secondary",
        textDecoration: "none",
        padding: "1.3125rem 28px 1.3125rem 36px !important",
        fontSize: "1rem",
        lineHeight: "20px",
        fontWeight: 500,

        display: "flex",
        alignItems: "center",
        "& .MuiSvgIcon-root": {
          mr: "1.25rem",
        },
        ...(isActive && {
          color: "secondary.main",
        }),
        "&:hover": {
          color: "secondary.main",
        },
      }}
      component={RouteLink}
      to={to}
    >
      {<Icon />}
      <span> {title}</span>
    </Link>
  );
};
